var _defs, _path, _rect, _line, _path2, _path3, _line2, _line3, _path4, _line4, _line5, _path5, _path6, _path7, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgcosmeticos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 485.16 487.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n.cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:10px;}\r\n.cls-2{fill:#fff;}\r\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.09,274.57H434.17A14.46,14.46,0,0,1,448.63,289V418.21a34.36,34.36,0,0,1-34.36,34.36H248a34.36,34.36,0,0,1-34.36-34.36V289A14.46,14.46,0,0,1,228.09,274.57Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 283.63,
    y: 377.57,
    width: 93,
    height: 35,
    rx: 17.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 213.63,
    y1: 336.01,
    x2: 448.63,
    y2: 336.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.63,248.57s-2-133-40-180c0,0,64-63,127,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.62,248.57s2-133,40-180"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 348.64,
    y1: 149.6,
    x2: 415.61,
    y2: 149.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 356.57,
    y1: 210.76,
    x2: 407.77,
    y2: 210.76
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.68,242.07l11.4-187a24,24,0,0,0-24-25.45h-161A24,24,0,0,0,43.22,55.06L67.68,446.14a6.85,6.85,0,0,0,6.84,6.43H190.64"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.35,
    y1: 89.01,
    x2: 250.01,
    y2: 89.01
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 61.92,
    y1: 354.07,
    x2: 118.13,
    y2: 354.07
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.72,362.57c3.93,0,7.68-3.45,7.5-7.5a7.63,7.63,0,0,0-7.5-7.5c-3.92,0-7.68,3.45-7.5,7.5a7.64,7.64,0,0,0,7.5,7.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.91,361.89c3.93,0,7.69-3.45,7.5-7.5a7.63,7.63,0,0,0-7.5-7.5c-3.92,0-7.68,3.45-7.5,7.5a7.64,7.64,0,0,0,7.5,7.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.55,452.57v-20a19,19,0,0,1,19-19H181.7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.63,
    y: 171.65,
    width: 67.99,
    height: 67.99,
    rx: 11.9,
    transform: "translate(-102.47 163.91) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgcosmeticos);
export default __webpack_public_path__ + "static/media/svgcosmeticos.7c3c3d40934261af383216022f926b30.svg";
export { ForwardRef as ReactComponent };